import { render, staticRenderFns } from "./FeatureHomeFour.vue?vue&type=template&id=9856fbc8&"
import script from "./FeatureHomeFour.vue?vue&type=script&lang=js&"
export * from "./FeatureHomeFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports